import moment from 'moment';

export default function PRAAddAssessmentDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  confirmDialog,
  praDataService,
  loaderService,
  performBusinessImpactAnalysisDialog,
  ssDialogService,
) {
  const vm = this;

  if (vm.assessment.dueDate) {
    vm.dueDate = moment(vm.assessment.dueDate);
  } else {
    vm.dueDate = moment().add(30, 'days');
  }

  vm.analysisMinDate = moment().add(1, 'days');

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleSelectOwnerName = _handleSelectOwnerName;
  vm.handleAddAssessmentFormSubmit = _handleAddAssessmentFormSubmit;
  vm.someOwnersSelected = _someOwnersSelected;

  function _handleCloseDialog() {
    _closeDialog();
  }

  function _closeDialog() {
    ssDialogService.hide(ssDialogService.dialogs.pra.addAssessmentDialog);
  }

  function _saveAssessment() {
    const dfdSave = $q.defer();

    if ($scope.addPRAAssessmentForm.$valid) {
      // Set the impact analysis date on assessment object
      vm.assessment.dueDate = vm.dueDate.format('MM/DD/YYYY');
      loaderService.showViewLoader = true;
      const _assessment = {};
      if (vm.assessment.assessmentId > 0) {
        _assessment.customerId = vm.assessment.customerId;
        _assessment.assessmentId = vm.assessment.assessmentId;
        _assessment.name = vm.assessment.name;
        _assessment.dueDate = vm.assessment.dueDate;
      } else {
        _assessment.customerId = 0;
        _assessment.assessmentId = 0;
        _assessment.name = vm.assessment.name;
        _assessment.dueDate = vm.assessment.dueDate;
      }

      praDataService.saveAssessment(_assessment).then(() => {
        loaderService.showViewLoader = false;
        alerts.success('The assessment has been successfully saved.');
        dfdSave.resolve();
        $rootScope.$broadcast('refreshPRAAssessments');
      });
    } else {
      dfdSave.reject();
    }
    return dfdSave.promise;
  }

  function _handleAddAssessmentFormSubmit($event) {
    if (vm.dueDate >= vm.analysisMinDate) {
      _saveAssessment().then(_closeDialog);
    } else {
      ssDialogService.dialogs.pra.confirmAssessmentPastDueDate = ssDialogService.alert(
        confirmDialog.getOptions($event, {
          dialogTitle: 'Save Assessment with Overdue Due Date?',
          message: 'The due date selected for the assessment is in the past, and thus non-compliant. Would you like to save the assessment anyway?', // eslint-disable-line
          handleYesClick: _handleConfirmPastDueDate,
          handleNoClick: _closeConfirmPastDueDateDialog,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.pra.confirmAssessmentPastDueDate);
    }
  }

  function _handleConfirmPastDueDate() {
    _closeConfirmPastDueDateDialog();
    _saveAssessment().then(() => {
      _closeDialog();
    });
  }

  function _closeConfirmPastDueDateDialog() {
    ssDialogService.hide(ssDialogService.dialogs.pra.confirmAssessmentPastDueDate);
  }

  function _handleSelectOwnerName(owner) {
    owner.isSelected = !owner.isSelected;
  }


  // Validation
  function _someOwnersSelected() {
    if (vm.assessment.assessmentNotifications) {
      return vm.assessment.assessmentNotifications.some(owner => owner.isSelected);
    }
    return false;
  }
}

PRAAddAssessmentDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'confirmDialog',
  'praDataService',
  'loaderService',
  'performBusinessImpactAnalysisDialog',
  'ssDialogService',
];
